export const MegaMenuKnowledgeCornerContent = () => {
  return (
    <div className="h-[23rem] px-3 py-9 bg-[#fcfcff]">
      <div className="grid grid-cols-2 mt-4">
        <a
          href="/knowledge-corner"
          className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 hover:bg-[#F3F4F8] cursor-pointer"
        >
          <div className="flex items-center gap-2">
            <div className="w-6 h-6"><img src="/img/icons/lightbulb-04-alt.svg" alt="light-bulb"/></div>
            <div className="mega-menu-submenu-title">Knowledge Corner</div>
          </div>
          <div className="mega-menu-submenu-text lg:w-[20rem]">Explore questions and articles on later life finance and retirement planning.</div>
        </a>

        <a
          href="/knowledge-corner/equity-release-faqs"
          className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 hover:bg-[#F3F4F8] cursor-pointer"
        >
          <div className="flex items-center gap-2">
            <div className="w-6 h-6"><img src="/img/icons/messsage-check-square-alt.svg" alt="message-check"/></div>
            <div className="mega-menu-submenu-title">Your FAQs Answered</div>
          </div>
          <div className="mega-menu-submenu-text lg:w-[20rem]">Find answers for your equity release and later life borrowing questions.</div>
        </a>

        <a
          href="/knowledge-corner/what-is-compound-interest"
          className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 hover:bg-[#F3F4F8] cursor-pointer"
        >
          <div className="flex items-center gap-2">
            <div className="w-5 h-5"><img src="/img/icons/compound-interest.svg" alt="light-bulb"/></div>
            <div className="mega-menu-submenu-title">What Is Compound Interest?</div>
          </div>
          <div className="mega-menu-submenu-text lg:w-[20rem]">Learn about compound interest and how it can impact a lifetime mortgage.</div>
        </a>

        <a
          href="#"
          className="p-5 rounded-lg flex flex-col justify-start items-start gap-2 opacity-50 cursor-not-allowed pointer-events-none hover:bg-[#F3F4F8]"
          aria-disabled="true"
        >
          <div className="flex items-center gap-2">
            <div className="w-6 h-6"><img src="/img/icons/clock-fast-forward.svg" alt="clock-fast"/></div>
            <div className="mega-menu-submenu-title">Later Life Borrowing And You</div>
          </div>
          <div className="mega-menu-submenu-text lg:w-[20rem]">Coming soon.</div>
        </a>
      </div>
    </div>
  );
};
